export default __webpack_public_path__ + "static/media/lightab_logo.5c08e211.svg";